import { DomainEvent } from "../model/domain-event.model";

export class ServiceDrawerAddedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor() {}
}

export class ServiceDrawerRemovedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor() {}
}

export class ServiceDrawerChangedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor() {}
} 